var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "20", height: "20" }, props),
    React.createElement(
      "g",
      { className: styles["nc-icon-wrapper"] || "nc-icon-wrapper", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", fill: "#2d9f86", stroke: "#2d9f86" },
      React.createElement("path", { "data-cap": "butt", fill: "none", strokeMiterlimit: "10", d: "M7.137 2.13A10.96 10.96 0 0 1 11.6 1.007C17.67.787 22.772 5.528 22.993 11.6S18.472 22.772 12.4 22.993 1.228 18.472 1.007 12.4a10.955 10.955 0 0 1 2.244-7.067", className: styles["nc-loop_circle-04-24"] || "nc-loop_circle-04-24" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/static/images/loading.svg